export const ClaimDocumentsTypes = {
  ENDING_VALUE_FORM: 'ENDING_VALUE_FORM',
  SALES_RECEIPT: 'SALES_RECEIPT',
  RETAINED_OWNERSHIP_FORM: 'RETAINED_OWNERSHIP_FORM',
  NOTICE_OF_PROBABLE_LOSS_FORM: 'NOTICE_OF_PROBABLE_LOSS_FORM',
  CLAIMS_PACKET: 'CLAIMS_PACKET',
} as const;

export type ClaimDocumentTypes =
  (typeof ClaimDocumentsTypes)[keyof typeof ClaimDocumentsTypes];

export const claimDocumentTypeToNameMap: Record<ClaimDocumentTypes, string> = {
  [ClaimDocumentsTypes.ENDING_VALUE_FORM]: 'EV Form',
  [ClaimDocumentsTypes.NOTICE_OF_PROBABLE_LOSS_FORM]: 'NoPL Form',
  [ClaimDocumentsTypes.RETAINED_OWNERSHIP_FORM]: 'Retained Ownership Form',
  [ClaimDocumentsTypes.CLAIMS_PACKET]: 'Claims Packet',
  [ClaimDocumentsTypes.SALES_RECEIPT]: 'Sales Receipt',
};
